module.exports = __webpack_public_path__ + "static/media/ins11.341753f2.jpg";